import authService from '@/services/auth'

export default {
  namespaced: true,

  state: {
    countries: [],
    roles: [],
    industries: [],
    companyTypes: [],
    companySizes: [],
    arcgisUses: [],
    email: '',
    firstName: '',
    lastName: '',
    fullName: '',
    phoneNumber: '',
    company: '',
    position: '',
    zipCode: '',
    country: '',
    role: '',
    industry: '',
    companyType: '',
    companySize: '',
    arcgisUse: '',
    checkPrivacy: false,
    checkAds: false,
    checkPartners: false,
    checkNotice: false,
    emailStatus: null,
    invalidEmailMessage:
      'Lo sentimos, pero el email con el que intentas acceder no se encuentra en el listado de asistentes. Por favor, asegúrate de que lo estás escribiendo correctamente',
    passwordMinLength: 6,
    oldPassword: '',
    password: '',
    repeatPassword: '',
    passwordTokenStatus: 'not-received',
    showAlert: false,
    access: localStorage.getItem('access') || '',
    refresh: localStorage.getItem('refresh') || '',
    wrongCredentials: false,
    wrongPassword: false,
    blockedUser: false,
    tooManyRequests: false,
    formSent: false,
  },

  getters: {
    userIsAuthenticated: state => !!state.refresh,
    validEmailAddress: state =>
      state.emailStatus === 'first-access' ||
      state.emailStatus === 'registered-user',
    invalidEmailAddress: state =>
      state.emailStatus === null ||
      state.emailStatus === 'invalid-email-address',
  },

  mutations: {
    updateCountries(state, countries) {
      state.countries = countries
    },

    updateRoles(state, roles) {
      state.roles = roles
    },

    updateIndustries(state, industries) {
      state.industries = industries
    },

    updateCompanyTypes(state, companyTypes) {
      state.companyTypes = companyTypes
    },

    updateCompanySizes(state, companySizes) {
      state.companySizes = companySizes
    },

    updateArcgisUses(state, arcgisUses) {
      state.arcgisUses = arcgisUses
    },

    updateFirstName(state, firstName) {
      state.firstName = firstName
    },

    updateLastName(state, lastName) {
      state.lastName = lastName
    },

    updateFullName(state, fullName) {
      state.fullName = fullName
    },

    updateEmail(state, email) {
      state.email = email
    },

    updatePhoneNumber(state, phoneNumber) {
      state.phoneNumber = phoneNumber
    },

    updateCompany(state, company) {
      state.company = company
    },

    updatePosition(state, position) {
      state.position = position
    },

    updateZipCode(state, zipCode) {
      state.zipCode = zipCode
    },

    updateCountry(state, country) {
      state.country = country
    },

    updateRole(state, role) {
      state.role = role
    },

    updateIndustry(state, industry) {
      state.industry = industry
    },

    updateCompanyType(state, companyType) {
      state.companyType = companyType
    },

    updateCompanySize(state, companySize) {
      state.companySize = companySize
    },

    updateArcgisUse(state, arcgisUse) {
      state.arcgisUse = arcgisUse
    },

    updateEmailStatus(state, status) {
      state.emailStatus = status
    },

    updatePasswordTokenStatus(state, status) {
      state.passwordTokenStatus = status
    },

    updateOldPassword(state, oldPassword) {
      state.oldPassword = oldPassword
    },

    updatePassword(state, password) {
      state.password = password
    },

    updateRepeatPassword(state, repeatPassword) {
      state.repeatPassword = repeatPassword
    },

    toggleCheckPrivacy(state) {
      state.checkPrivacy = !state.checkPrivacy
    },

    toggleCheckAds(state) {
      state.checkAds = !state.checkAds
    },

    toggleCheckPartners(state) {
      state.checkPartners = !state.checkPartners
    },

    updateCheckPrivacy(state, status) {
      state.checkPrivacy = status
    },

    updateCheckAds(state, status) {
      state.checkAds = status
    },

    updateCheckPartners(state, status) {
      state.checkPartners = status
    },

    toggleCheckNotice(state) {
      state.checkNotice = !state.checkNotice
    },

    resetChangePassword(state) {
      state.oldPassword = ''
      state.password = ''
      state.repeatPassword = ''
    },

    showAlert(state, status) {
      state.showAlert = status
    },

    updateAccess(state, token) {
      localStorage.setItem('access', token)
      state.access = token
    },

    updateRefresh(state, token) {
      localStorage.setItem('refresh', token)
      state.refresh = token
    },

    removeTokens(state) {
      localStorage.removeItem('access')
      localStorage.removeItem('refresh')
      state.access = ''
      state.refresh = ''
    },

    removeUtmTags() {
      localStorage.removeItem('utm_source')
      localStorage.removeItem('utm_medium')
      localStorage.removeItem('utm_campaign')
      localStorage.removeItem('utm_term')
      localStorage.removeItem('utm_content')
    },

    setWrongCredentials(state, status) {
      state.wrongCredentials = status
    },

    setWrongPassword(state, status) {
      state.wrongPassword = status
    },

    setBlockedUser(state, status) {
      state.blockedUser = status
    },

    setTooManyRequests(state, status) {
      state.tooManyRequests = status
    },

    updateFormSent(state, status) {
      state.formSent = status
    },
  },

  actions: {
    fetchRegisterParams({ commit }) {
      authService.getCountries().then(res => {
        commit('updateCountries', res)
      })
      authService.getRoles().then(res => {
        commit('updateRoles', res)
      })
      authService.getIndustries().then(res => {
        commit('updateIndustries', res)
      })
      authService.getCompanyTypes().then(res => {
        commit('updateCompanyTypes', res)
      })
      authService.getCompanySizes().then(res => {
        commit('updateCompanySizes', res)
      })
      authService.getArcgisUses().then(res => {
        commit('updateArcgisUses', res)
      })
    },

    checkEmailAddress({ commit, dispatch }, payload) {
      return new Promise(resolve => {
        commit('forms/setSendingData', true, { root: true })
        authService.checkEmailAddress(payload).then(res => {
          commit('setWrongCredentials', false)
          commit('forms/setSendingData', false, { root: true })
          if (res.response) {
            if (res.response.status === 404) {
              commit('setWrongCredentials', true)
              commit('updateEmailStatus', 'invalid-email-address')
            } else if (res.response.status === 429) {
              commit('setTooManyRequests', true)
            }
          } else {
            const payload = {
              email: res.email,
              emailStatus: res.status,
              firstName: res.first_name,
              lastName: res.last_name,
            }
            dispatch('updateValidAttendeeData', payload)
            resolve()
          }
        })
      })
    },

    updateValidAttendeeData(
      { commit },
      { email, emailStatus, firstName, lastName }
    ) {
      commit('updateEmail', email)
      commit('updateEmailStatus', emailStatus)
      commit('updateFirstName', firstName)
      commit('updateLastName', lastName)
    },

    resetUserData({ commit }) {
      commit('updateFirstName', '')
      commit('updateLastName', '')
      commit('updateFullName', '')
      commit('updateEmailStatus', null)
      commit('updateEmail', '')
      commit('updatePassword', '')
      commit('updateRepeatPassword', '')
    },

    obtainToken({ commit }, { service, payload }) {
      commit('forms/setSendingData', true, { root: true })
      return new Promise(resolve => {
        authService[service](payload).then(res => {
          commit('forms/setSendingData', false, { root: true })
          if (res.response) {
            if (res.response.status === 400) {
              commit('forms/setServerErrors', res.response.data, { root: true })
            } else if (res.response.status === 429) {
              commit('setTooManyRequests', true)
            }
          } else if (res.is_blocked) {
            commit('setBlockedUser', true)
          } else if (res.access) {
            commit('setShowMenu', false, { root: true })
            commit('setWrongCredentials', false)
            commit('setBlockedUser', false)
            commit('setTooManyRequests', false)
            commit('updateAccess', res.access)
            commit('updateRefresh', res.refresh)
            resolve()
          }
        })
      })
    },

    registerUser({ dispatch }, payload) {
      return new Promise(resolve => {
        dispatch('obtainToken', { service: 'registerUser', payload }).then(
          () => {
            resolve()
          }
        )
      })
    },

    loginUser({ dispatch }, payload) {
      return new Promise(resolve => {
        dispatch('obtainToken', { service: 'loginUser', payload }).then(() => {
          resolve()
        })
      })
    },

    refreshToken({ commit }, refresh) {
      return new Promise(resolve => {
        authService.refreshToken({ refresh }).then(res => {
          if (res.access) {
            commit('updateAccess', res.access)
          }
          resolve(res.access)
        })
      })
    },

    fetchUser({ commit }) {
      authService.getUser().then(res => {
        commit('updateEmail', res.email)
        commit('updateFullName', res.full_name)
      })
    },

    changePassword({ commit }, payload) {
      authService.changePassword(payload).then(res => {
        if (res.response) {
          if (res.response.status === 400) {
            commit('forms/setServerErrors', res.response.data, { root: true })
          }
        } else {
          commit('showAlert', true)
          commit('resetChangePassword')
        }
      })
    },

    forgottenPassword({ state, commit }, payload) {
      commit('forms/setSendingData', true, { root: true })
      authService.forgottenPassword(payload).then(res => {
        commit('forms/setSendingData', false, { root: true })
        if (res.response) {
          if (res.response.status === 404) {
            const errors = { email: [state.invalidEmailMessage] }
            commit('forms/setServerErrors', errors, { root: true })
          }
        } else {
          commit('showAlert', true)
          commit('updateEmail', '')
        }
      })
    },

    checkResetPasswordToken({ commit }, token) {
      authService.checkResetPasswordToken(token).then(res => {
        if (res.response) {
          if (res.response.status === 404) {
            commit('updatePasswordTokenStatus', 'invalid')
          }
        }
      })
    },

    resetPassword({ commit }, { token, payload }) {
      commit('forms/setSendingData', true, { root: true })
      authService.resetPassword(token, payload).then(res => {
        commit('forms/setSendingData', false, { root: true })
        if (res.response) {
          if (res.response.status === 400) {
            commit('forms/setServerErrors', res.response.data, { root: true })
          }
          if (res.response.status === 404) {
            commit('updatePasswordTokenStatus', 'invalid')
          }
        } else {
          commit('updatePasswordTokenStatus', 'password-changed')
          commit('updatePassword', '')
          commit('updateRepeatPassword', '')
        }
      })
    },

    logOut({ commit, dispatch }) {
      commit('removeTokens')
      commit('removeUtmTags')
      dispatch('resetUserData')
      return new Promise(resolve => {
        authService.logOut().then(() => {
          resolve()
        })
      })
    },
  },
}
